// ==============================|| MODELS ||============================== //

import { ReservedCapacityGuardingActionTypeEnum } from 'features/dispatcher/dispatcherReservedCapacityGuardingTypes';

export enum PanelRkColumn {
  OOM = 'oom',
  DEVICE = 'device',
  PRIORITY = 'priority',
  CURRENT_POWER = 'currentPower',
  CONSUMED_POWER = 'consumedPower',
  ESTIMATED_CONSUMPTION = 'estimatedConsumption',
  SUGGESTED_CONSUMPTION = 'suggestedConsumption',
  GUARDING_ACTION_TYPE = 'guardingActionType',
  REQUIRED_CONSUMPTION = 'requiredConsumption',
  START_OF_MEASUREMENT = 'startOfMeasurement',
  ISSUANCE_OF_MEASUREMENT = 'issuanceOfMeasurement',
  LEAVE_FOR_LATER = 'leaveForLater',
  UNIT_PRICE_OF_ENERGY = 'unitPriceOfEnergy',
  DEVIATION_ESTIMATE = 'deviationEstimate',
  NOMINATION = 'nomination'
}

export interface RkTableCellByDevice {
  offtake: number | undefined;
  supply: number | undefined;
  deviceRole?: string;
  deviceType?: string;
}

export interface RkTableRow {
  id: string;
  [PanelRkColumn.OOM]: string;
  [PanelRkColumn.DEVICE]: string;
  [PanelRkColumn.PRIORITY]: number | undefined;
  [PanelRkColumn.CURRENT_POWER]: number | undefined;
  [PanelRkColumn.CONSUMED_POWER]: RkTableCellByDevice;
  [PanelRkColumn.ESTIMATED_CONSUMPTION]: RkTableCellByDevice;
  [PanelRkColumn.SUGGESTED_CONSUMPTION]: number | undefined;
  [PanelRkColumn.GUARDING_ACTION_TYPE]:
    | ReservedCapacityGuardingActionTypeEnum
    | undefined;
  [PanelRkColumn.ISSUANCE_OF_MEASUREMENT]: string | undefined;
  [PanelRkColumn.START_OF_MEASUREMENT]: string | undefined;
  [PanelRkColumn.LEAVE_FOR_LATER]: boolean | undefined;
  [PanelRkColumn.UNIT_PRICE_OF_ENERGY]: number | undefined;
  [PanelRkColumn.DEVIATION_ESTIMATE]: number | undefined;
  [PanelRkColumn.NOMINATION]: number | string | undefined;

  rowType: 'device' | 'summary-row';
}
